import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overlay-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "overlay__inner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "overlay__content" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "spinner" })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}